import React from 'react';
import { connect } from 'react-redux';
import { Formik, Form, ErrorMessage } from 'formik';
import { Container, Grid, Radio, RadioGroup } from '@material-ui/core';
import BoxWrapper from 'components/atoms/BoxWrapper';
import Button from 'components/atoms/Button/Button';
import * as Yup from 'yup';
import FormControlChooseOption from 'components/atoms/FormControlChooseOption';
import { setActiveRadio } from 'utils/SetActiveToRadio';
import CustomTypography from 'components/atoms/CustomTypography';
import { colors, fonts } from 'theme/Variables';
import { privacyPolicy } from 'localdata/registerPage/steps/stepTen';
import { Link, Redirect } from 'react-router-dom';
import { routes } from 'routes/Routes';
import styled from 'styled-components';
import { register as registerAction } from 'actions/authentication';
import { convertFieldsFromRegisterToNumber } from 'utils/ConvertOptionsFromRegisterToNumber';
import LoadingScreen from 'components/molecules/LoadingScreen';
import { isDisabled } from '../../../utils/buttonFormIsDisabled';

const StyledLink = styled.a`
    color: ${colors.secondary['200']};
    text-decoration: none;
    margin-left: 0.5rem;
`;

const StyledErrorMessage = styled.p`
    font-size: 1.2rem;
    color: ${colors.secondary['500']};
    margin-top: 0;
`;

const StyledForm = styled(Form)`
    position: relative;
`;

const stepTenValidationSchema = Yup.object().shape({
    privacy_policy: Yup.string().matches(/(1)/, { message: 'You must accept to continue!' }),
});

const StepTen = ({ setValuesToFormData, register, data, authentication }) => {
    const convertedData = convertFieldsFromRegisterToNumber(data);

    const { isRegisterRequest, isRegisterSuccess, isRegisterFailure } = authentication;

    return (
        <Container>
            <BoxWrapper mt="50">
                <Grid container justify="center">
                    <Grid item xs={12} md={4}>
                        <Formik
                            initialValues={{
                                privacy_policy: '',
                            }}
                            validationSchema={stepTenValidationSchema}
                            onSubmit={(values) => {
                                setValuesToFormData(values);
                                register(convertedData);
                            }}
                        >
                            {({ values, handleChange, handleBlur, isValid }) => (
                                <StyledForm>
                                    <BoxWrapper mb="50" justifyContent="flex-start">
                                        <CustomTypography
                                            variant="h3"
                                            fontSize="2.6"
                                            customfont={fonts.secondary}
                                        >
                                            Our terms
                                        </CustomTypography>
                                        <CustomTypography mt="2">
                                            Mobilise will contact you via SMS and Email to deliver
                                            daily questions and information related to your caring
                                            situation. Your data will be used according to our
                                            <StyledLink
                                                href="https://www.mobiliseonline.co.uk/data-privacy-notice"
                                                target="_blank"
                                            >
                                                privacy policy
                                            </StyledLink>
                                            .
                                        </CustomTypography>
                                    </BoxWrapper>
                                    <BoxWrapper mb="50" justifyContent="flex-start">
                                        <RadioGroup
                                            name="privacy_policy"
                                            defaultValue={values.privacy_policy}
                                            value={values.privacy_policy}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className="w-100"
                                        >
                                            {privacyPolicy.map(
                                                ({ value, label, instruction, option }) => (
                                                    <FormControlChooseOption
                                                        key={value}
                                                        value={value}
                                                        control={
                                                            <Radio
                                                                color="secondary"
                                                                label={label}
                                                            />
                                                        }
                                                        label={label}
                                                        option={option}
                                                        instruction={instruction}
                                                        labelPlacement="start"
                                                        active={setActiveRadio(
                                                            values.privacy_policy,
                                                            value,
                                                        )}
                                                    />
                                                ),
                                            )}
                                            <ErrorMessage
                                                name="privacy_policy"
                                                render={(msg) => (
                                                    <StyledErrorMessage>{msg}</StyledErrorMessage>
                                                )}
                                            />
                                        </RadioGroup>
                                    </BoxWrapper>

                                    <BoxWrapper>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            mt="20"
                                            width="50"
                                            type="submit"
                                            disabled={isDisabled(values, isValid)}
                                        >
                                            Continue
                                        </Button>
                                    </BoxWrapper>
                                    {isRegisterRequest && <LoadingScreen />}
                                    {isRegisterSuccess && <Redirect to={routes.thankYouRoute} />}
                                </StyledForm>
                            )}
                        </Formik>
                    </Grid>
                </Grid>
            </BoxWrapper>
        </Container>
    );
};

const mapStateToProps = ({ authentication }) => {
    return { authentication };
};

const mapDispatchToProps = (dispatch) => {
    return {
        register: (data) => dispatch(registerAction(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(StepTen);
